export enum OrderingDocsEnum {
    Nome = 'Nome', 
    Data = 'Data de disponibilidade',
    Distancia = 'Distância',
}